import {FC, useContext} from 'react';
import {StringUtils} from 'common/utils/string-utils';
import {ConceptID} from 'features/terms/felles-datakatalog/concept-ids';
import {useTranslation} from 'react-i18next';
import {termDescriptionContext} from '../term-provider';
import {useLang} from 'features/i18n/use-lang';

interface FdkTextProps {
  conceptId: ConceptID;
  definitionFieldName?: 'remark' | 'text';
}

export const FdkText: FC<FdkTextProps> = ({conceptId, definitionFieldName = 'text'}) => {
  const lang = useLang();
  const {t} = useTranslation();
  const {conceptDefinitions} = useContext(termDescriptionContext);
  const definition = conceptDefinitions[conceptId]?.[definitionFieldName];

  if (definition) {
    return <>{StringUtils.capitalize(definition[lang] ?? definition.nb)}</>;
  } else {
    return <>{t('common:failed_to_load')}</>;
  }
};
